<template>
    <v-layout
        row
        wrap
    >
        <v-flex
            v-if="productReturn.status"
            xs12
        >
            <span class="subheading font-weight-bold">
                Status: <span class="font-weight-regular">{{ statusText }}</span>
            </span>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                :headers="headers"
                :items="productReturn.products"
                hide-actions
            >
                <template v-slot:items="props">
                    <td>{{ props.item.itemNumber }}</td>
                    <td>{{ props.item.description }}</td>
                    <td class="shrink-column">
                        {{ props.item.quantityToReturn }} / {{ props.item.quantity }}
                    </td>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex xs12>
            <v-divider />
        </v-flex>
        <v-flex
            xs12
            md6
        >
            <h3 class="title mb-1">
                Customer
            </h3>
            <p>{{ productReturn.customerName }}</p>
            <h3 class="title mb-1">
                Pickup Location for Return
            </h3>
            <p>
                {{ productReturn.company }}<br>
                {{ productReturn.address }}<br>
                {{ productReturn.city }}, {{ productReturn.state }} {{ productReturn.zipcode }}
            </p>
        </v-flex>
        <v-flex
            xs12
            md6
        >
            <h3 class="title mb-1">
                Customer Contact for Return
            </h3>
            <p>
                {{ productReturn.contactName }}<br>
                {{ maskedPhone }}<br>
                {{ productReturn.contactEmail }}
            </p>
        </v-flex>
        <v-flex
            xs12
            v-if="productReturn.comment || productReturn.files.length !== 0"
        >
            <v-divider />
        </v-flex>
        <v-flex
            xs12
            v-if="productReturn.comment"
        >
            <h3 class="title mb-1">
                Comment
            </h3>
            <p
                class="text-body"
            >{{ productReturn.comment }}</p>
        </v-flex>
        <v-flex
            xs12
            md6
            v-if="productReturn.files.length !== 0"
        >
            <h3 class="title mb-1">
                Product Photos
            </h3>
            <ul class="file-list">
                <li
                    v-for="file in productReturn.files"
                    :key="file.filename"
                >
                    <template v-if="disableFileDownload">
                        {{ file.filename }}
                    </template>
                    <template v-else>
                        <a
                            :href="fileApi + encodeURIComponent(file.path)"
                            target="_blank"
                        >
                            {{ file.filename }}
                        </a>
                    </template>
                </li>
            </ul>
        </v-flex>
        <v-flex
            xs12
            md6
            v-if="productReturn.internalFiles.length !== 0"
        >
            <h3 class="title mb-1">
                Internal Docs
            </h3>
            <ul class="file-list">
                <li
                    v-for="file in productReturn.internalFiles"
                    :key="file.filename"
                >
                    <template v-if="disableFileDownload">
                        {{ file.filename }}
                    </template>
                    <template v-else>
                        <a
                            :href="fileApi + file.path"
                            target="_blank"
                        >
                            {{ file.filename }}
                        </a>
                    </template>
                </li>
            </ul>
        </v-flex>
        <v-flex
            v-if="officeUse"
            xs12
        >
            <v-divider />
        </v-flex>
        <v-flex
            xs12
            md6
            v-if="officeUse"
        >
            <h3 class="title mb-1">
                For Office Use
            </h3>
            <key-value-table>
                <tbody>
                    <tr>
                        <td>
                            CRT #
                        </td>
                        <td>
                            {{ productReturn.crtNumber | showAbsence }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            PRO #
                        </td>
                        <td>
                            {{ productReturn.proNumber | showAbsence }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Credit Memo #
                        </td>
                        <td>
                            {{ productReturn.creditMemoNumber | showAbsence }}
                        </td>
                    </tr>
                </tbody>
            </key-value-table>
        </v-flex>
        <v-flex v-if="$slots.footer">
            <slot name="footer" />
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
import { statuses } from '../utils/constants/statuses'

const headers = [
    {
        text: 'Product #',
        sortable: false,
        value: 'itemNumber'
    },
    {
        text: 'Product Name',
        sortable: false,
        value: 'description'
    },
    {
        text: 'Quantity to Return',
        sortable: false,
        value: 'quantity'
    }
]

export default {
    props: {
        productReturn: {
            type: Object,
            required: true
        },
        officeUse: {
            type: Boolean,
            default: false
        },
        disableFileDownload: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            headers,
            fileApi: axios.defaults.baseURL + '/uploads/'
        }
    },
    computed: {
        maskedPhone: function () {
            return this.productReturn.contactPhone
                ? this.productReturn.contactPhone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3')
                : null
        },
        statusText: function () {
            return this.productReturn && statuses[this.productReturn.status]
                ? statuses[this.productReturn.status].text
                : null
        }
    }
}
</script>

<style lang="scss" scoped>
.text-body {
    white-space: pre-line;
}
</style>
